import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import bndLogo2 from "../../assets/images/footer/Logo-white.png";
import { BsTwitter, BsLinkedin, BsYoutube, BsFacebook } from "react-icons/bs";
import paymentLogoImg from '../../assets/images/paywith_mobile_versionW.png';
import ScrollToTop from './ScrollToTop';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <div className='footer bg-neutral-800'>
            <div className='container mx-auto pt-5 px-14'>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                    <div className='ab'>
                        <h3 className='text text-yellow-200 font-normal text-xl pb-4'>{t('fotr.footerTabs.about')}</h3>
                        <img className='object-fill w-56 h-auto' src={bndLogo2} alt="" />
                        <p className='text text-gray-300 text-xs pt-3  '>
                            {t('fotr.das')}                        </p>
                    </div>
                    <div>
                        <h3 className='text text-amber-200 font-normal text-xl pb-4'>{t('fotr.footerTabs.quick')}</h3>
                        <ul className='text-white'>
                            {/* <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.About')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Home')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Floor-Freshener')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Perfumes')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Spray')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Oud-nd-Bakhor')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Mubkhr')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Zaafran')}</li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>{t('fotr.footerNavs.Offers')}</li> */}
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/about" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.About')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Home')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/floorFreshener" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Floor-Freshener')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/perfume" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Perfumes')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/sleepingSpray" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Spray')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/Oud-nd-Bakhor" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Oud-nd-Bakhor')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/Mubkhr" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Mubkhr')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/Zaafran" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Zaafran')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/nav-filter/Offers" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Offers')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/contact-us" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Contact-us')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/terms-and-conditions" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.Terms-and')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/knowledge" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.how-to-buy')}
                                </Link>
                            </li>
                            <li className='text-sm pt-1 pb-1 text-gray-300'>
                                <Link to="/knowledge/returns-and-refunds" className='hover:no-underline hover:text-inherit'>
                                    {t('fotr.footerNavs.returns-and-refunds')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 className='text text-amber-200 font-normal text-xl pb-4'>{t('fotr.footerTabs.payment')}</h3>
                        <img className='w-30 object-fill h-auto' src={paymentLogoImg} alt="payment logos" />
                        <h3 className='text text-amber-200 font-normal text-xl pt-3 pb-3'>{t('fotr.footerTabs.Follow-us')}</h3>
                        <div className='flex gap-4'>
                            <a className='hover:text-bnd-1 text-white-bnd' href="https://instagram.com/deer_parfum" target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-instagram  text-3xl" aria-hidden="true"></i>
                            </a>
                            <a className='hover:text-bnd-1 text-white-bnd' href="https://twitter.com/DeerParfum" target="_blank" rel="noopener noreferrer">
                                <BsTwitter className=" text-3xl" />
                            </a>
                            <a className='hover:text-bnd-1 text-white-bnd' href="https://www.linkedin.com/in/deer-pafrum" target="_blank" rel="noopener noreferrer">
                                <BsLinkedin className=" text-3xl" />
                            </a>
                            <a className='hover:text-bnd-1 text-white-bnd' href="https://www.youtube.com/@deerparfum2302" target="_blank" rel="noopener noreferrer">
                                <BsYoutube className=" text-3xl" />
                            </a>
                            <a className='hover:text-bnd-1 text-white-bnd' href="https://www.facebook.com/deer.parfum" target="_blank" rel="noopener noreferrer">
                                <BsFacebook className=" text-3xl" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className='mt-4 text-white text-center py-3 border-t border-gray-500 pb-1'>
                    <p className='text-sm pb-4'>Copyright © 2022 | Deer-Perfum.com</p>
                </div>
            </div>

            {/* <MessengerChat /> */}
            <ScrollToTop/>
        </div>

    );
};

export default Footer;